import { render, staticRenderFns } from "./rating-scale.vue?vue&type=template&id=a0cb0b48&scoped=true"
import script from "./rating-scale.vue?vue&type=script&lang=js"
export * from "./rating-scale.vue?vue&type=script&lang=js"
import style0 from "./rating-scale.vue?vue&type=style&index=0&id=a0cb0b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cb0b48",
  null
  
)

export default component.exports